<template>
<v-container>
    <v-layout row class="text-xs-right">
      <v-flex xs12>
        <p> You are logged out from your session. </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style>
</style>
<script>
//import UserModel from '../../api/service/UserService.js';

import UserModel from '@/api/service/UserService';

export default {
  data: () => ({
  }),
  created () {
    localStorage.removeItem(process.env.VUE_APP_LOCAL_STORAGE)
    UserModel.logout();
    location.reload(true)
  },
  methods: {
  }
};
</script>

<style  scoped>
  .style-input {
    padding:0px;
    margin:0px;
    width:100%;
  }
  .style-input1 {
    background-color:yellow;
  }
</style>
